
import {createRouter} from "vue-router"
import {createWebHashHistory,createWebHistory} from "vue-router"
 
// const helloWorld = () => import("../components/HelloWorld")
// const index = () => import("../page/index")

const routes = [
    // {path: '/', redirect: '/chat'},
    {
      path: "/",
      name: "surveyquestionnaire",
      component: () => import("../page/index")
    },
    {
      path: "/surveyindexPageOne",
      name: "indexPageOne",
      component: () => import("../page/indexPageOne")
    },
    // {
    //   path: "/call",
    //   name: "call",
    //   component: () => import("../page/call")
    // }
  ]
 const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_HISTORY_URL),
    // mode: 'history',
    // base:'/wecom/',
    routes
  })
// const router =  new VueRouter({
//   mode: 'hash', // history
//   routes:[
//     {
//         //主页
//         path:"/",
//         component:home
//     },
//   ]
// })	//返回实例


export default router